module.exports = __webpack_public_path__ + "static/media/pillow.5443b988.png";